import { STORE_COMMIT, STORE_GETTER } from "../store/store";

export const pageMixin = {
	data() {
		return {
			pageMenuList: [],

		};
	},

	computed: {


	
	},

	methods: {

		isPageMenuVisible(name) {

			const menu = this.pageMenuList.find(menu => menu.name == name)
			if (menu) {
				return menu.visible

			}

			return false
		},

		isAnyPageMenuVisible() {

			return this.pageMenuList.find(menu => menu.visible) != null

		},

		hidePageMenu(name) {
			console.log('FP: hidePageMenu: ', name);
			const menu = this.pageMenuList.find(menu => menu.name == name)
			menu.visible = false;
			this.$store.commit(STORE_COMMIT.SET_PAGE_MENU_OPEN, false);

		},
		showPageMenu(name) {
			console.log('FP: showPageMenu: ', name);

			const menu = this.pageMenuList.find(menu => menu.name == name)
			menu.visible = true;
			this.$store.commit(STORE_COMMIT.SET_PAGE_MENU_OPEN, true);

			this.hideAllPageMenuExcept(name)

		},

		hideAllPageMenu() {
			this.pageMenuList.map(menu => {
				menu.visible = false;
			})
			this.$store.commit(STORE_COMMIT.SET_PAGE_MENU_OPEN, false);
		},
		hideAllPageMenuExcept(name) {
			this.pageMenuList.map(menu => {
				if (menu.name != name) {
					menu.visible = false;
				}

			})
		},
		togglePageMenu(name) {

			console.log('FP: tooglePageMenu: ', name);

			const menu = this.pageMenuList.find(menu => menu.name == name)

			if (menu.visible) {
				this.hidePageMenu(name)
			} else {
				this.showPageMenu(name);
			}



		},

		togglePageMenuOpen() {
			const isPageMenuOpen = this.$store.getters[STORE_GETTER.IS_PAGE_MENU_OPEN]

			this.$store.commit(STORE_COMMIT.SET_PAGE_MENU_OPEN, !isPageMenuOpen);
		},
		
		showProductSerachPopover(){ // FP: 2026 anropas från SearchProductTextfield

			if (!this.isPageMenuVisible("menuSearch")) {
				this.showPageMenu('menuSearch');
			}
		}


	}
}
